import React from 'react'

import { GiReceiveMoney } from 'react-icons/gi'
import { TbWashMachine, TbTruckDelivery } from 'react-icons/tb'
import { MdPending } from 'react-icons/md'

import Chart from 'react-apexcharts'
import { Card } from '@material-tailwind/react'

import Layout from '@/Shared/Layout'
import { usePage } from '@inertiajs/react'

const Index = () => {
  const { washed, received, dispatch } = usePage().props

  const options = {
    chart: {
      id: 'line-chart',
      width: '900'
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
    }
  }

  const series = [
    {
      name: 'series-1',
      data: [30, 40, 45, 50, 49, 60, 70, 91]
    }
  ]

  return (
    <div>
      <div className="mb-8 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
        <div className="shadow-xs min-w-0 overflow-hidden rounded-lg bg-white dark:bg-gray-800">
          <div className="flex items-center p-4">
            <div className="mr-4 rounded-full bg-orange-100 p-3 text-orange-500 dark:bg-orange-500 dark:text-orange-100">
              <GiReceiveMoney size={30} />
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Received
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {received}
              </p>
            </div>
          </div>
        </div>

        <div className="shadow-xs min-w-0 overflow-hidden rounded-lg bg-white dark:bg-gray-800">
          <div className="flex items-center p-4">
            <div className="mr-4 rounded-full bg-green-100 p-3 text-green-500 dark:bg-green-500 dark:text-green-100">
              <TbWashMachine size={30} />
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Washed
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {washed}
              </p>
            </div>
          </div>
        </div>
        <div className="shadow-xs min-w-0 overflow-hidden rounded-lg bg-white dark:bg-gray-800">
          <div className="flex items-center p-4">
            <div className="mr-4 rounded-full bg-blue-100 p-3 text-blue-500 dark:bg-blue-500 dark:text-blue-100">
              <TbTruckDelivery size={30} />
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Dispatched
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {dispatch}
              </p>
            </div>
          </div>
        </div>
        <div className="shadow-xs min-w-0 overflow-hidden rounded-lg bg-white dark:bg-gray-800">
          <div className="flex items-center p-4">
            <div className="mr-4 rounded-full bg-teal-100 p-3 text-teal-500 dark:bg-teal-500 dark:text-teal-100">
              <MdPending size={30} />
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Pending
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                0
              </p>
            </div>
          </div>
        </div>
      </div>

      <Card className="mt-4 p-4">
        <Chart options={options} series={series} type="line" height="600" />
      </Card>
    </div>
  )
}

Index.layout = page => <Layout title="Laundry Dashboard" children={page} />

export default Index
